import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import cls from 'classnames';
import styles from './index.module.scss';

interface TermSwitchTabProps {
  className?: string;
  children: React.ReactNode;
  value: number;
  onValueChange: (val: number) => void;
}

interface TabItemProps {
  value: number;
  children: React.ReactNode;
}

type ContextDataType = Pick<TermSwitchTabProps, 'value' | 'onValueChange'> & {
  values: number[];
  setValues: React.Dispatch<React.SetStateAction<number[]>>;
  setHighlightBarTop: React.Dispatch<React.SetStateAction<number>>;
};

const context = React.createContext<ContextDataType>({
  value: -1,
  values: [],
  setValues: () => {},
  onValueChange: () => {},
  setHighlightBarTop: () => {}
});

function TabItem({ value, children }: TabItemProps) {
  const store = useContext(context);
  const tabRef = useRef<HTMLDivElement>(null);
  const highlighted = value === store.value;

  const className = useMemo(() => {
    if (highlighted) {
      setTimeout(() => {
        const shouldBeTop = tabRef.current?.offsetTop! + tabRef.current?.clientHeight! / 2 - 16;
        store.setHighlightBarTop(shouldBeTop || 0);
      }, 0);
    }
    return cls(styles.tabItem, {
      [styles.highlight]: highlighted
    });
  }, [highlighted]);

  const onClick = () => {
    store.onValueChange(value);
  };

  useEffect(() => {
    store.setValues((vals) => [...vals, value]);
    return () => {
      store.setValues((vals) => {
        const newVals = [...vals];
        const index = vals.indexOf(value);
        if (index === -1) {
          return vals;
        }
        newVals.splice(index, 1);
        return newVals;
      });
    };
  }, [value]);

  return (
    <div ref={tabRef} className={className} onClick={onClick}>
      {children}
    </div>
  );
}

function TermSwitchTab({ className, children, value, onValueChange }: TermSwitchTabProps) {
  const [values, setValues] = useState<number[]>([]);
  const [highlightBarTop, setHighlightBarTop] = useState(-100);

  console.log('value', value);

  const highlightStyle = {
    '--highlight-top': `${highlightBarTop + 2}px`
  } as React.CSSProperties;

  return (
    <context.Provider
      value={{
        value,
        values,
        setValues,
        onValueChange,
        setHighlightBarTop
      }}
    >
      <div className={cls(styles.container, className)} style={highlightStyle}>
        {children}
      </div>
    </context.Provider>
  );
}

TermSwitchTab.TabItem = TabItem;

export default TermSwitchTab;
